'use client';

import { FC } from 'react';
import Button from '@/components/Button/Button';
import MainBodyToReact from '../MainBodyToReact';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import CustomImage from '@/components/CustomImage/CustomImage';

interface FeaturedProductCardProps {
    id?: string;
    title: string;
    summary: any;
    image: string | undefined;
    path: string;
    buttonLabel: string;
    target?: string;
}

const FeaturedProductCard: FC<FeaturedProductCardProps> = ({
    id,
    title,
    summary,
    image,
    path,
    buttonLabel,
    target,
}) => {
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    return (
        <div className="lg:tw-w-[680px] md:tw-w-[464px] tw-w-full tw-bg-white tw-rounded-lg tw-p-[20px] sm:tw-p-[30px] tw-shadow-md ">
            <h3
                className="tw-text-[28px] tw-text-[#003865]"
                {...inspectorProps({ fieldId: 'title' })}
            >
                {title}
            </h3>
            <div className="tw-flex tw-my-[15px] tw-flex-col-reverse lg:tw-flex-row">
                <div className="tw-w-full " {...inspectorProps({ fieldId: 'content' })}>
                    <MainBodyToReact
                        body={summary}
                        classes={{
                            p: 'tw-text-[16px] lg:tw-pr-[20px] tw-leading-7 tw-font-gotham-book tw-text-[#303030]',
                        }}
                    />
                    <div
                        className="tw-w-[225px] tw-pt-[28px]"
                        {...inspectorProps({ fieldId: 'buttonLabel' })}
                    >
                        {buttonLabel && <Button label={buttonLabel} path={path} target={target} />}
                    </div>
                </div>
                <div className="tw-w-full">
                    <div
                        className="tw-w-full lg:tw-ml-auto md:tw-mr-auto md:tw-w-[344px] lg:md:tw-w-[281px] tw-h-[175px] sm:tw-h-[200px] lg:tw-h-[163px] tw-rounded-lg tw-mb-[24px] tw-overflow-hidden"
                        {...inspectorProps({ fieldId: 'image' })}
                    >
                        <CustomImage
                            src={image || ''}
                            width={281}
                            height={163}
                            alt={title}
                            className="tw-w-[100%] tw-rounded-lg"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturedProductCard;
